import React, { useState } from 'react';
import { Row, Col, Typography, Modal, Flex } from 'antd';
import ArrowButton from '../../../shared/ArrowButton/ArrowButton';
import useMobileCheck from '../../../mobile';
import './CTASection.css';
import { getAppLoginUrl } from '../../../shared/appUrl';
import { useLocation } from 'react-router-dom';
import { captureDemoModalOpened } from '../../../analytics';

const { Title, Paragraph } = Typography;

const CTASection = () => { 
  const [ modalOpen, setModalOpen ] = useState(false);
  const { isMobile } = useMobileCheck();
  const location = useLocation();

  const modalStyles = {
    body: {
      height: '100%'
    },
    mask: {
      backdropFilter: 'blur(10px)',
    },
    content: {
      height: "100%",
      overflowY: 'scroll'
    },
  };

  const padding = isMobile ? '5px' : '80px';

  return (
    <>
      <Modal
        title="Book a demo"
        centered
        open={modalOpen}
        footer={null}
        onCancel={() => setModalOpen(false)}
        width={`calc(100% - ${padding})`}
        height={`calc(100% - ${padding})`}
        styles={modalStyles}
        className="signup-modal"
      >
        <iframe 
          style={{
            width: '100%', 
            height: '100%',
            border: 0
          }}
          src="https://meet.brevo.com/andy-feltham/intro-to-shuttleops"/>
      </Modal>
      <div className="cta-bg">
        <Flex 
          vertical
          align={ isMobile ? 'flex-start' : 'center' }
          className="cta-section">

          <Title 
            level={location.pathname.startsWith('/pulse') ? 2 : 1}
            style={{ 
              textAlign: isMobile ? 'left' : 'center'
            }}
            className="cta-title">
            Ready to elevate your badminton club management?
          </Title>

          <Paragraph 
            style={{ 
              textAlign: isMobile ? 'left' : 'center'
            }}
            className="cta-body">
            Join ShuttleOps today and experience the future of seamless club operations.
          </Paragraph>

          <Flex 
            vertical={isMobile}
            gap={16}
            style={{ 
              paddingTop: '16px'
            }}
            justify="center" className="cta-btn-row-tmp">
            <ArrowButton
              onClick={() => { 
                window.location = getAppLoginUrl();
              }}
            >Sign Up Now</ArrowButton>
            <ArrowButton variant="white"
              onClick={() => { 
                captureDemoModalOpened(location.pathname, 'page_call_to_action');
                setModalOpen(true);
              }}
            >Request a Demo</ArrowButton>
          </Flex>
        </Flex>
      </div>
    </>
  );
}

export default CTASection;
